import { render, staticRenderFns } from "./SpecificEventPage.vue?vue&type=template&id=0fa624e9&scoped=true&"
import script from "./SpecificEventPage.vue?vue&type=script&lang=js&"
export * from "./SpecificEventPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificEventPage.vue?vue&type=style&index=0&id=0fa624e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa624e9",
  null
  
)

export default component.exports